import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import TabPanel from 'components/TabPanel'
import { Button, DialogConfirm } from 'components'
import { Send } from '@mui/icons-material'
import {
  Address,
  AdesionTerms,
  QuestionEight,
  QuestionEighteen,
  QuestionEleven,
  QuestionFifteen,
  QuestionFive,
  QuestionFour,
  QuestionFourteen,
  QuestionNine,
  QuestionOne,
  QuestionSeven,
  QuestionSeventeen,
  QuestionSix,
  QuestionSixteen,
  QuestionTen,
  QuestionThirteen,
  QuestionThree,
  QuestionTwelve,
  QuestionTwo,
} from 'components/DueDiligence/Questions'
import { put } from 'services/api'
import _, { cloneDeep } from 'lodash'
import { useSelector } from 'react-redux'

import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { gotoUrl } from 'utils/functions'
import { toast } from 'react-toastify'
import TimelineStepper from 'components/TimelineStepper'

import { Alert, AlertTitle, Typography } from '@mui/material'
import { DATA_FIELDS_NAMES } from 'utils/constants/dataFields'
import styles from './styles'
import PageLayout from './DesktopLayout'

function DesktopForm(props) {
  const { dueDiligence, setDueDiligence } = props

  const classes = styles()

  const [formComplete, setFormComplete] = useState(false)

  const form_uuid = useSelector((state) => state.form.uuid)
  const token = useSelector(state => state.auth.access_token)

  const [activeStep, setActiveStep] = React.useState(0)
  const [completed, setCompleted] = React.useState({})
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [animateNextButton, setAnimateNextButton] = useState(false)
  const [formErrors, setFormErrors] = useState([])
  const [showFormErrorMessages, setShowFormErrorMessages] = useState(false)

  const steps = [
    'Endereço e redes sociais',
    'Administração de carteiras e atividades ambientais',
    'Atividades e produtos externos',
    'Produtos internacionais e entidades financeiras',
    'Robôs automatizados e parentescos',
    'PEP e procurações',
    'Investimentos fora da XP e sanções regulatórias',
    'Ações judiciais e inquéritos',
    'Mídia negativa e listas restritivas',
    'Corretoras e termos de adesão',
  ]
  const stepsMapping = {
    address: steps[0],
    social_networks: steps[0],

    financial_activities: steps[1],
    environment_related_activities: steps[1],

    external_activities: steps[2],
    national_product_offering_activities: steps[2],

    international_product_offering_activities: steps[3],
    representation_activities: steps[3],

    automation_activities: steps[4],
    kinship_xp: steps[4],

    pep_relationship: steps[5],
    attorney_activities: steps[5],

    third_party_investments: steps[6],
    court_lawsuit_cvm_bacen_sfn: steps[6],

    environmental_court_lawsuit: steps[7],
    criminal_court_lawsuit: steps[7],

    negative_media: steps[8],
    restrictive_list: steps[8],

    terms_agreement: steps[9],
    relation_with_another_companies: steps[9],
  }

  const totalSteps = () => {
    return steps.length
  }

  const completedSteps = () => {
    return Object.keys(completed).length
  }

  const isLastStep = () => {
    return activeStep === totalSteps() - 1
  }

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps()
  }


  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const handleAnimateNextButton = () => {
    setAnimateNextButton(true)
    setTimeout(() => {
      setAnimateNextButton(false)
    }, 1500)
  }

  const handleComplete = () => {
    const newCompleted = cloneDeep(completed)
    newCompleted[activeStep] = true
    setCompleted(newCompleted)
    if (!isLastStep()) handleAnimateNextButton()
  }

  const updateForm = (newState, isPageComplete) => {
    setDueDiligence(newState)
    if (isPageComplete) {
      handleComplete()
    }
  }

  const handleStep = (step) => () => {
    setActiveStep(step)
  }

  const handleEndForm = () => {
    setOpenConfirmDialog(true)
  }

  const handleCloseConfirm = () => {
    setShowFormErrorMessages(false)
    setOpenConfirmDialog(false)
  }

  const handleFormAnswerValidationErrors = (data) => {
    const errors = data?.errors || []
    const newErrors = errors.map((e) => {
      return { ...e, stepName: stepsMapping[e.question_name] }
    })
    setShowFormErrorMessages(true)
    setFormErrors(newErrors)
  }

  const handleFinishConfirm = async () => {
    await put({
      url: `/due_diligence/pf/form/finish?form_uuid=${form_uuid}`,
      token,
    })
      .then(() => {
        handleCloseConfirm()
        toast.success(
          'Formulário preenchido com sucesso, em breve você será redirecionado à página inicial.',
        )
        gotoUrl(ROUTE_CONSTANTS.DUE_DILIGENCE_RESUME)
      })
      .catch((error) => {
        if (error?.response?.data?.message === 'Invalid form answers') {
          handleFormAnswerValidationErrors(error.response.data)
        }
        else {
          toast.error(
            error?.response?.data?.details ||
            'Houve um erro ao realizar esta ação, por favor, tente novamente',
          )
        }
      })
  }

  const handleNext = () => {
    if (isLastStep()) {
      if (!allStepsCompleted()) {
        // Se for o último passo, mas nem todos os passos estiverem completos,
        // encontra o primeiro passo que não estiver completo
        const nextActiveStep = steps.findIndex((step, i) => !(i in completed))
        setActiveStep(nextActiveStep)
      } else {
        setActiveStep(0)
      }
    } else {
      setActiveStep(activeStep + 1)
    }
  }

  const handleStepsInitialize = () => {
    const stepsCompleted = cloneDeep(completed)
    stepsCompleted['0'] =
      dueDiligence?.address?.has_answer &&
      dueDiligence?.social_networks?.has_answer

    stepsCompleted['1'] =
      dueDiligence.financial_activities.has_answer &&
      dueDiligence.environment_related_activities.has_answer

    stepsCompleted['2'] =
      dueDiligence.external_activities.has_answer &&
      dueDiligence.national_product_offering_activities.has_answer

    stepsCompleted['3'] =
      dueDiligence.international_product_offering_activities.has_answer &&
      dueDiligence.representation_activities.has_answer

    stepsCompleted['4'] =
      dueDiligence.automation_activities && dueDiligence.kinship_xp.has_answer

    stepsCompleted['5'] =
      dueDiligence.pep_relationship &&
      dueDiligence.attorney_activities.has_answer

    stepsCompleted['6'] =
      dueDiligence.third_party_investments.has_answer &&
      dueDiligence.court_lawsuit_cvm_bacen_sfn.has_answer

    stepsCompleted['7'] =
      dueDiligence.environmental_court_lawsuit &&
      dueDiligence.criminal_court_lawsuit.has_answer

    stepsCompleted['8'] =
      dueDiligence.negative_media && dueDiligence.restrictive_list.has_answer

    stepsCompleted['9'] =
      dueDiligence.terms_agreement.has_answer &&
      dueDiligence.relation_with_another_companies.has_answer

    setCompleted(stepsCompleted)
  }

  useEffect(() => {
    const keys = Object.keys(dueDiligence)
    const complete = keys.every((key) => dueDiligence[key].has_answer)
    setFormComplete(complete)
    handleStepsInitialize()
  }, [dueDiligence])

  return (
    <div className={classes.container}>
      <div className={classes.paginationContainer}>
        <Button onClick={handleBack} disabled={activeStep < 1}>
          Etapa anterior
        </Button>
        <Button
          disabled={!formComplete}
          color="warning"
          onClick={handleEndForm}
        >
          <span
            style={{
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            Enviar respostas&nbsp;&nbsp;{' '}
            <Send
              sx={{ transform: 'rotate(-25deg) translateY(-4px)' }}
              fontSize="small"
            />
          </span>
        </Button>
        <Button
          onClick={handleNext}
          disabled={isLastStep()}
          className={animateNextButton ? classes.nextButtonAnimation : ''}
        >
          Próxima Etapa
        </Button>
      </div>

      <div className={classes.wrapper}>
        <TimelineStepper
          steps={steps}
          activeStep={activeStep}
          completed={completed}
          handleStep={handleStep}
          formErrors={formErrors}
        />
        <TabPanel key="page_one" value={0} index={activeStep}>
          <PageLayout
            key="page_one"
            formData={dueDiligence}
            updateForm={updateForm}
            LeftComponent={Address}
            RightComponent={QuestionOne}
            leftQuestionKey="address"
            rightQuestionKey="social_networks"
          />
        </TabPanel>
        <TabPanel key="page_two" value={1} index={activeStep}>
          <PageLayout
            key="page_two"
            formData={dueDiligence}
            updateForm={updateForm}
            LeftComponent={QuestionTwo}
            RightComponent={QuestionThree}
            leftQuestionKey="financial_activities"
            rightQuestionKey="environment_related_activities"
          />
        </TabPanel>
        <TabPanel key="page_three" value={2} index={activeStep}>
          <PageLayout
            key="page_three"
            formData={dueDiligence}
            updateForm={updateForm}
            LeftComponent={QuestionFour}
            RightComponent={QuestionFive}
            leftQuestionKey="external_activities"
            rightQuestionKey="national_product_offering_activities"
          />
        </TabPanel>
        <TabPanel key="page_four" value={3} index={activeStep}>
          <PageLayout
            key="page_four"
            formData={dueDiligence}
            updateForm={updateForm}
            LeftComponent={QuestionSix}
            RightComponent={QuestionSeven}
            leftQuestionKey="international_product_offering_activities"
            rightQuestionKey="representation_activities"
          />
        </TabPanel>
        <TabPanel key="page_five" value={4} index={activeStep}>
          <PageLayout
            key="page_five"
            formData={dueDiligence}
            updateForm={updateForm}
            LeftComponent={QuestionEight}
            RightComponent={QuestionNine}
            leftQuestionKey="automation_activities"
            rightQuestionKey="kinship_xp"
          />
        </TabPanel>
        <TabPanel key="page_six" value={5} index={activeStep}>
          <PageLayout
            key="page_six"
            formData={dueDiligence}
            updateForm={updateForm}
            LeftComponent={QuestionTen}
            RightComponent={QuestionEleven}
            leftQuestionKey="pep_relationship"
            rightQuestionKey="attorney_activities"
          />
        </TabPanel>
        <TabPanel key="page_seven" value={6} index={activeStep}>
          <PageLayout
            key="page_seven"
            formData={dueDiligence}
            updateForm={updateForm}
            LeftComponent={QuestionTwelve}
            RightComponent={QuestionThirteen}
            leftQuestionKey="third_party_investments"
            rightQuestionKey="court_lawsuit_cvm_bacen_sfn"
          />
        </TabPanel>
        <TabPanel key="page_eight" value={7} index={activeStep}>
          <PageLayout
            key="page_eight"
            formData={dueDiligence}
            updateForm={updateForm}
            LeftComponent={QuestionFourteen}
            RightComponent={QuestionFifteen}
            leftQuestionKey="environmental_court_lawsuit"
            rightQuestionKey="criminal_court_lawsuit"
          />
        </TabPanel>
        <TabPanel key="page_nine" value={8} index={activeStep}>
          <PageLayout
            key="page_nine"
            formData={dueDiligence}
            updateForm={updateForm}
            LeftComponent={QuestionSixteen}
            RightComponent={QuestionSeventeen}
            leftQuestionKey="negative_media"
            rightQuestionKey="restrictive_list"
          />
        </TabPanel>
        <TabPanel key="page_ten" value={9} index={activeStep}>
          <PageLayout
            key="page_ten"
            formData={dueDiligence}
            updateForm={updateForm}
            LeftComponent={QuestionEighteen}
            RightComponent={AdesionTerms}
            leftQuestionKey="relation_with_another_companies"
            rightQuestionKey="terms_agreement"
          />
        </TabPanel>
      </div>

      <DialogConfirm
        open={openConfirmDialog}
        onCancel={handleCloseConfirm}
        onConfirm={handleFinishConfirm}
        title="Tem certeza que deseja finalizar o preenchimento e enviar as respostas do formulário cadastral?"
        btnCancelText="cancelar"
      >

        {(!_.isEmpty(formErrors) && showFormErrorMessages) && <Alert severity='warning' color='error'>
          <AlertTitle>Respostas incompletas</AlertTitle>
          As seguintes respostas não estão completas:
          <ul>
            {_.map(formErrors, (error) => (
              <li key={error.question_name}>{DATA_FIELDS_NAMES[error.question_name]}</li>
            ))}
          </ul>
          Volte no formulário e preencha as informações faltantes para prosseguir.
        </Alert>}
        <br></br>
        <Typography variant='subtitle1'>
          Ao confirmar a ação, você não poderá mais editar suas respostas. Caso
          deseje revisar alguma das questões, clique em cancelar.
        </Typography>
      </DialogConfirm>
    </div>
  )
}

DesktopForm.propTypes = {
  dueDiligence: PropTypes.object.isRequired,
}

export default DesktopForm
